function DealershipGuide() {
  return (
    <div className="p-7 text-gray-800">
      <h2 className="text-xl font-bold mb-6">Dealership / Demo / Free Booking Functionality Guide</h2>

      <div className="mb-8 bg-white p-6 rounded-lg shadow">
        <h3 className="font-medium text-lg mb-4 border-b pb-2">Brief overview</h3>
        <p className="mb-3">
          Dealership functionality is created in order to allow a person to create a group and administrate it using the
          backoffice tool. This group is used as a way to determine whether or not a car is allowed to be shared for
          free. The car/availability will be hidden from all non-members of the group.
        </p>
        <p className="mb-3">
          A backoffice super admin adds a user to the 'dealership admin' list and provides this user with the dealership
          user permission. This allows the user to administrate his own dealership in the dealership tab in the
          backoffice tool. From there the user can add & remove both vins and users.
        </p>
        <p className="mb-3">
          Now when the owner shares this car in carsharing, carsharing will check if the owner is a 'dealership admin'.
          If true then it will check if owner is in any dealership and if the car is in that dealership. If true then
          the vehicle settings will have its payment setting overwritten to be free and the car will be shared for all
          members/users in the dealership.
        </p>
        <p className="text-sm text-gray-600">
          (Depending on how the car has been shared previously, the lender may need to update its vehicle-settings
          first, any update should work, you can add/remove an equipment)
        </p>
      </div>

      <div className="mb-8 bg-white p-6 rounded-lg shadow">
        <h3 className="font-medium text-lg mb-4 border-b pb-2">Flow</h3>
        <p className="mb-4">
          Text in square brackets refers to where in the backoffice tool the functionality is found.
        </p>
        <div className="mb-4">
          <p>
            <strong className="font-semibold">Backoffice super-admin:</strong> Any user with highest permission in the
            backoffice tool.
          </p>
          <p>
            <strong className="font-semibold">Owner1:</strong> A user which owns a car and which will get its own
            dealership.
          </p>
          <p>
            <strong className="font-semibold">Borrower1:</strong> A user which will be added as a member to the Owner1's
            dealership and will be able to see & book the cars in Owner1's dealership for free.
          </p>
        </div>
        <ol className="list-decimal list-inside space-y-2">
          <li>
            Backoffice super-admin adds Owner1 to dealership admin list{' '}
            <code className="bg-gray-200 p-1 rounded text-sm">[Backoffice - Dealerships - Administrators tab]</code>.
          </li>
          <li>
            Backoffice super-admin gives Owner1 Dealership User permission{' '}
            <code className="bg-gray-200 p-1 rounded text-sm">
              [Backoffice - Admin - Users - Edit User - Dealership Management - Dealership User]
            </code>
            .
          </li>
          <li>
            Owner1 signs into backoffice tool and navigates to{' '}
            <code className="bg-gray-200 p-1 rounded text-sm">[Dealerships - Dealerships]</code>.
          </li>
          <li>Owner1 adds the VIN it is intending to share for free to its dealership.</li>
          <li>Owner1 adds Borrower1 that should be able to book the car for free to its dealership.</li>
          <li>Owner1 shares the car, may need to make small update to vehicle-setting (Any change will do).</li>
          <li>
            At this point the Borrower1 will be able to see and book the car in the app just like any booking, but it
            will be free.
          </li>
        </ol>
      </div>

      <div className="mb-8 bg-white p-6 rounded-lg shadow">
        <h3 className="font-medium text-lg mb-4 border-b pb-2">Notes</h3>
        <ul className="list-disc list-inside space-y-2">
          <li>
            Only members in the dealership will be able to see and book the car, membership status is required for
            booking.
          </li>
          <li>
            If the dealership is removed at any point during a booking, the booking will continue to function as
            expected.
          </li>
          <li>
            Dealerships are automatically removed and all availabilities within the dealership will be cleaned up if the
            Owner loses its status as 'dealership admin'.
          </li>
        </ul>
      </div>

      <div className="mb-8 bg-red-50 p-6 rounded-lg shadow">
        <h3 className="font-medium text-lg mb-4 text-red-800 border-b border-red-200 pb-2">Troubleshooting</h3>
        <ul className="list-none space-y-4">
          <li>
            <strong className="font-semibold text-red-700">Errors when sharing the car:</strong>
            <p className="pl-2 mt-1">
              Lender might need to make an adjustment to their vehicle-settings after having become a dealership owner &
              adding the vin to the dealership.
            </p>
          </li>
          <li>
            <strong className="font-semibold text-red-700">Borrower can not see the car:</strong>
            <ul className="list-disc list-inside space-y-1 pl-4 mt-1">
              <li>
                Borrower is not a member of the dealership - super admin or dealership owner needs to add the user.
              </li>
              <li>Borrower has been signed up for a market that is not the same as the vehicle.</li>
            </ul>
          </li>
          <li>
            <strong className="font-semibold text-red-700">Borrower unable to book the car:</strong>
            <p className="pl-2 mt-1">Verify the borrower is not also the owner of the same vin.</p>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default DealershipGuide;
